import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot, query, where, and, or } from "firebase/firestore";

export function useAdmins(env, client) {
  const [loadedAdmins, setLoadedAdmins] = useState(false);
  const [admins, setAdmins] = useState(null);

  useEffect(() => {
    setLoadedAdmins(false);
    if (!client) {
      setLoadedAdmins(true);
      return () => [];
    }
    const ref = collection(db, "users");
    const q = query(
      ref,
      and(
        where('disabled', '==', false),
        or(
          where('role', '==', 'super-admin'),
          where(`clients.${env}`, "array-contains-any", [client, "__all__"]),
        )
      )
    );
    const unsub = onSnapshot(q, (snapshot) => {
      const data = [];
      snapshot.docs.forEach((doc) => {
        data.push({
          id: doc.id,
          email: doc.data().email
        });
      });
      setAdmins(data);
      setLoadedAdmins(true);
    });
    return () => unsub();
  }, [env, client]);

  return { loadedAdmins, admins };
}